import "@fortawesome/fontawesome-pro/css/all.css";

import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';

import Swiper from "swiper/swiper-bundle";

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import AOS from 'aos';

import Instafeed from 'instafeed.js';
import registrationPage from "./custom/registrationPage";

window.Instafeed = Instafeed;

$(function () {

    basicNavigation();
    if($('.BinCleaningRegistrationPage').length > 0){
        registrationPage();
    }


    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');


    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    const swiper = new Swiper('.swiper', {
        loop: true,
        autoplay: {
            delay: 5000,
        },
        effect: 'fade',
    });

    AOS.init({
        once: true,
        delay: 150,
    });

});
